import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span>FuturePathTech · futurepathtech.dev</span>
        <nav className="footer-links">
          <Link to="/ping">Ping</Link>
          <Link to="/post">Post</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
        <span>CRM billed monthly · USD</span>
      </div>
    </footer>
  );
}
